// extracted by css-extract-rspack-plugin
var _1 = "AplxYl1hRuNanmXG5Igqlg--";
export { _1 as "container" }
